import { render } from "./AIKnowledgeBase.vue?vue&type=template&id=daddc644&scoped=true"
import script from "./AIKnowledgeBase.vue?vue&type=script&lang=js"
export * from "./AIKnowledgeBase.vue?vue&type=script&lang=js"

import "./AIKnowledgeBase.vue?vue&type=style&index=0&id=daddc644&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-daddc644"]])

export default __exports__